import type { ComponentProps } from 'react';

export const DoneIcon = (props:ComponentProps<'svg'>) => (
  <svg width="174" height="132" viewBox="0 0 174 132" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_i_727_1155)">
      <path
        d="M148.785 4.00868C154.851 -1.62285 164.342 -1.27908 169.984 4.77636C175.626 10.8319 175.281 20.3062 169.215 25.9378L55.7754 131.25L4.78493 83.9124C-1.28135 78.2807 -1.62579 68.8065 4.01588 62.751C9.65755 56.6956 19.1488 56.3518 25.2151 61.9833L55.7754 90.3543L148.785 4.00868Z"
        fill="currentColor" />
    </g>
    <defs>
      <filter id="filter0_i_727_1155" x="0" y="0" width="174" height="135.75" filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha" />
        <feOffset dy="4.5" />
        <feGaussianBlur stdDeviation="2.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_727_1155" />
      </filter>
    </defs>
  </svg>


)